import { render, staticRenderFns } from "./GrowerBankAccountsTab.vue?vue&type=template&id=453c6054&scoped=true"
import script from "./GrowerBankAccountsTab.vue?vue&type=script&lang=js"
export * from "./GrowerBankAccountsTab.vue?vue&type=script&lang=js"
import style0 from "./GrowerBankAccountsTab.vue?vue&type=style&index=0&id=453c6054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c6054",
  null
  
)

export default component.exports